var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSkip = function SvgSkip(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.4 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.93,8.33a.47.47,0,0,0-.47.47A6.26,6.26,0,1,1,7.2,2.54h.52l-.8.8a.48.48,0,0,0,0,.67.47.47,0,0,0,.33.14A.48.48,0,0,0,7.59,4l1.6-1.6a.48.48,0,0,0,0-.67L7.59.14a.47.47,0,0,0-.67,0,.47.47,0,0,0,0,.66l.8.8H7.2a7.2,7.2,0,1,0,7.2,7.2A.47.47,0,0,0,13.93,8.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.57,2.07,9.3,3.34A.46.46,0,0,0,9.3,4,.46.46,0,0,0,10,4l1.61-1.6a.48.48,0,0,0,0-.67L10,.14a.45.45,0,0,0-.66,0A.45.45,0,0,0,9.3.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.71 11.23 5.71 6.46 4.13 6.46 4.13 7.31 4.77 7.31 4.77 11.23 5.71 11.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,6.37c-1.34,0-1.76,1-1.76,2.41s.42,2.44,1.76,2.44,1.77-1,1.77-2.44S9.85,6.37,8.5,6.37Zm0,4c-.77,0-.86-.74-.86-1.59s.09-1.56.86-1.56.86.75.86,1.56S9.27,10.37,8.5,10.37Z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSkip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Skip.f6e0a471.svg";
export { ForwardRef as ReactComponent };